var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "question-mark_svg__a",
    cx: 32,
    cy: 32,
    r: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#question-mark_svg__a",
    fill: "#1f7ed6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.342 36.43c.01-.97.586-1.848 1.47-2.246a9.598 9.598 0 0 0-2.524-18.028 9.56 9.56 0 0 0-7.852 2.07A9.56 9.56 0 0 0 22 25.585a2.773 2.773 0 1 0 5.547 0c0-1.197.53-2.334 1.442-3.107a3.96 3.96 0 0 1 3.328-.86 4.08 4.08 0 0 1 3.218 3.218 4.05 4.05 0 0 1-2.191 4.354 8.08 8.08 0 0 0-4.549 7.239v.499a2.773 2.773 0 1 0 5.547 0zm-3.827 6.268a2.5 2.5 0 0 0-1.498 1.498 2.775 2.775 0 0 0 3.606 3.605c.336-.142.645-.336.915-.582a2.775 2.775 0 0 0 .582-3.023 2.8 2.8 0 0 0-.582-.915 2.775 2.775 0 0 0-3.023-.583"
  }))));
};
export default SvgQuestionMark;